/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimReservationCommunicationMethod } from './ClaimReservationCommunicationMethod';
import {
    ClaimReservationCommunicationMethodFromJSON,
    ClaimReservationCommunicationMethodFromJSONTyped,
    ClaimReservationCommunicationMethodToJSON,
} from './ClaimReservationCommunicationMethod';

/**
 * 
 * @export
 * @interface ResendClaimFormNotificationResponse
 */
export interface ResendClaimFormNotificationResponse {
    /**
     * 
     * @type {ClaimReservationCommunicationMethod}
     * @memberof ResendClaimFormNotificationResponse
     */
    method: ClaimReservationCommunicationMethod;
    /**
     * 
     * @type {string}
     * @memberof ResendClaimFormNotificationResponse
     */
    sentTo: string;
}



/**
 * Check if a given object implements the ResendClaimFormNotificationResponse interface.
 */
export function instanceOfResendClaimFormNotificationResponse(value: object): value is ResendClaimFormNotificationResponse {
    if (!('method' in value) || value['method'] === undefined) return false;
    if (!('sentTo' in value) || value['sentTo'] === undefined) return false;
    return true;
}

export function ResendClaimFormNotificationResponseFromJSON(json: any): ResendClaimFormNotificationResponse {
    return ResendClaimFormNotificationResponseFromJSONTyped(json, false);
}

export function ResendClaimFormNotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendClaimFormNotificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'method': ClaimReservationCommunicationMethodFromJSON(json['method']),
        'sentTo': json['sentTo'],
    };
}

export function ResendClaimFormNotificationResponseToJSON(value?: ResendClaimFormNotificationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'method': ClaimReservationCommunicationMethodToJSON(value['method']),
        'sentTo': value['sentTo'],
    };
}

